import React, { useState, useEffect } from 'react'

import _ from 'i18n';

const SidePageHeaderPopPup = ({ app,
  subHeader,
  tabContainer,
  organization,
  year = [],
  appRefs = [],
  appRefsStore = []
}) => {


  const renderYearItems = () => {
    let other = 0;
    if (year.length > 3) {

      other = year.length - 3;
    }
    let years = [];
    year.map((item, i) => {

      if (i == 0) {
        years.push(item);
      }
      else if (year.length <= 3 && i == year.length - 1) {
        years.push(_('and') + ' ' + item);
      } else {
        if (i <= 2) {
          years.push(', ' + item);
        }
      }

      return years;
    })

    const test = years.join(' ');
    return (
      <div>
        <p className="sub-header">{test} {(other > 0) ? <span> {_('and')} <strong>{other} {_('other_year')}.</strong></span> : null} </p>
      </div>
    )
  }


  const renderAppRefsItems = () => {
    let other = 0;
    if (appRefs.length > 3) {

      other = appRefs.length - 3;
    }
    let appRefs = [];

    let names = [];
    appRefs.map((id) => {

      appRefsStore.filter(item => {

        if (item.id == id) {
          return names.push(item.nameFr)
        }
      })
    })

    names.map((item, i) => {

      if (i == 0) {
        appRefs.push(item);
      }
      else if (appRefs.length <= 3 && i == appRefs.length - 1) {
        appRefs.push(_('and') + ' ' + item);
      } else {
        if (i <= 2) {
          appRefs.push(', ' + item);
        }
      }
      return appRefs;
    })

    const test = appRefs.join(' ');
    return (
      <div>
        <p className="sub-header">{test} {(other > 0) ? <span> {_('and')} <strong>{other} {_('other_event')}.</strong></span> : null} </p>
      </div>
    )
  }

  return <div style={{ marginLeft: "-100px" }}>
    <div className="side-page-header__info">

      {organization ? <div className="flex">
        <p className="sub-header"> {organization} </p> </div> : null}

      {year && year.length > 0 ? <div className="flex"> <img src="/img/icons/Arrow.svg" />
        <p className="sub-header"> {renderYearItems()} </p> </div> : null
      }

      {appRefs.length > 0 ? <div className="flex"> <img src="/img/icons/Arrow.svg" />

        <p className="sub-header"> {renderAppRefsItems()} </p> </div>
        : <div className="flex"> <img src="/img/icons/Arrow.svg" />
          <p className="sub-header"> {_("none-event")} </p> </div>
      }

    </div>
  </div>
};

export default SidePageHeaderPopPup;



// WEBPACK FOOTER //
// ./app/components/common/SidePageHeaderPopUp.js